import { ISelection } from "src/constants/interfaces/bet";

export const getPrice = (selection: ISelection) =>
	selection.event.sp || selection.event.eventOption ? -1 : selection.alternateOdd || selection.event.price || 0;
